
export default function getFeatures(state) {
  return state.features;
}
